export const MODALS = {
  createEvent: 'create-event',
  createAckEvent: 'create-ack-event',
  confirmAckWithTicket: 'confirm-ack-with-ticket',
  createAssociateTicketEvent: 'create-associate-ticket-event',
  removeAssociatedTicketEvent: 'remove-associated-ticket-event',
  createCommentEvent: 'create-comment-event',
  createChangeStateEvent: 'create-change-state-event',
  createSnoozeEvent: 'create-snooze-event',
  variablesHelp: 'variables-help',

  serviceDependencies: 'service-dependencies',
  createServicePauseEvent: 'create-service-pause-event',
  editLiveReporting: 'edit-live-reporting',
  infoPopupSetting: 'info-popup-setting',
  addInfoPopup: 'add-info-popup',
  confirmation: 'confirmation',
  confirmationPhrase: 'confirmation-phrase',
  clickOutsideConfirmation: 'click-outside-confirmation',
  createWidget: 'create-widget',
  selectWidgetTemplateType: 'select-widget-template-type',
  createWidgetTemplate: 'create-widget-template',
  createFilter: 'create-filter',
  alarmsList: 'alarms-list',
  createAlarmChart: 'create-alarm-chart',
  colorPicker: 'color-picker',
  textEditor: 'text-editor',
  textEditorWithTemplate: 'text-editor-with-template',
  textFieldEditor: 'text-field-editor',
  payloadTextareaEditor: 'payload-textarea-editor',
  selectView: 'select-view',
  createView: 'create-view',
  shareView: 'share-view',
  createGroup: 'create-group',
  createUser: 'create-user',
  createRole: 'create-role',
  createBroadcastMessage: 'create-broadcast-message',
  createCommentTemplate: 'create-comment-template',
  createAnomalyMonitoredConnector: 'create-anomaly-monitored-connector',
  anomalyMonitoredConnectorHistory: 'anomaly-monitored-connector-history',
  createEventFilter: 'create-event-filter',
  createMetaAlarmRule: 'create-meta-alarm-rule',
  createPattern: 'create-pattern',
  eventFilterActions: 'event-filter-actions',
  createEventFilterAction: 'create-event-filter-action',
  filtersList: 'filters-list',
  createSnmpRule: 'create-snmp-rule',
  selectViewTab: 'select-view-tab',
  createDynamicInfo: 'create-dynamic-info',
  createDynamicInfoInformation: 'create-dynamic-info-information',
  importExportViews: 'import-groups-and-views',
  dynamicInfoTemplatesList: 'dynamic-info-templates-list',
  createDynamicInfoTemplate: 'create-dynamic-info-template',
  createPlaylist: 'create-playlist',
  managePlaylistTabs: 'manage-playlist-tabs',

  pbehaviorList: 'pbehavior-list',
  pbehaviorPlanning: 'pbehavior-planning',
  pbehaviorsCalendar: 'pbehaviors-calendar',
  pbehaviorRecurrenceRule: 'pbehavior-recurrence-rule',
  createRecurrenceRule: 'create-recurrence-rule',
  pbehaviorRecurrentChangesConfirmation: 'pbehavior-recurrent-changes-confirmation',
  createPbehavior: 'create-pbehavior',
  createPbehaviorType: 'create-pbehavior-type',
  createPbehaviorReason: 'create-pbehavior-reason',
  createPbehaviorException: 'create-pbehavior-exception',
  importPbehaviorException: 'import-pbehavior-exception',

  linkToMetaAlarm: 'link-to-meta-alarm',
  removeAlarmsFromMetaAlarm: 'remove-alarms-from-meta-alarm',
  createRemediationInstruction: 'create-remediation-instruction',
  createRemediationConfiguration: 'create-remediation-configuration',
  createRemediationJob: 'create-remediation-job',
  createTicketStatusJob: 'create-ticket-status-job',
  executeRemediationInstruction: 'execute-remediation-instruction',
  executeRemediationSimpleInstruction: 'execute-remediation-simple-instruction',
  pbehaviorPatterns: 'pbehavior-patterns',
  remediationInstructionApproval: 'remediation-instruction-approval',

  imageViewer: 'image-viewer',
  imagesViewer: 'images-viewer',
  rate: 'rate',
  createScenario: 'create-scenario',
  testSuite: 'test-suite',
  createIdleRule: 'create-idle-rule',
  createAlarmStatusRule: 'create-alarm-status-rule',
  healthcheckEngine: 'healthcheck-engine',
  healthcheckEnginesChainReference: 'healthcheck-engines-chain-reference',
  info: 'info',
  createKpiFilter: 'create-kpi-filter',
  createMap: 'create-map',
  createGeoMap: 'create-geo-map',
  createFlowchartMap: 'create-flowchart-map',
  createMermaidMap: 'create-mermaid-map',
  createTreeOfDependenciesMap: 'create-tree-of-dependencies-map',

  createShareToken: 'create-share-token',

  createDeclareTicketEvent: 'create-declare-ticket-event',
  createDeclareTicketRule: 'create-declare-ticket-rule',
  executeDeclareTickets: 'execute-declare-tickets',

  createLinkRule: 'create-link-rule',

  createLlm: 'create-llm',
  aiChatHistory: 'ai-chat-history',

  createMaintenance: 'create-maintenance',

  createTag: 'create-tag',

  createEntity: 'create-entity',
  createService: 'create-service',
  entityDependenciesList: 'entity-dependencies-list',
  entitiesRootCauseDiagram: 'entities-root-cause-diagram',
  entityUpstream: 'entity-upstream',
  createEntityInfoProperty: 'create-entity-info-property',
  createEntityInfo: 'create-entity-info',
  serviceEntities: 'service-entities',
  entitiesList: 'entities-list',
  entitiesComparison: 'entities-comparison',

  createTheme: 'create-theme',

  createStateSetting: 'create-state-setting',
  createJunitStateSetting: 'create-junit-state-setting',
  stateSettingInheritedEntityPattern: 'state-setting-inherited-entity-pattern',

  createIcon: 'create-icon',

  eventsRecord: 'events-record',
  applyEventFilter: 'apply-event-filter',

  duration: 'duration',

  createExternalDataTable: 'create-external-data-table',
  createExternalDataTableRecord: 'create-external-data-table-record',
  importExternalDataTableRecords: 'import-external-data-table-records',

  createTemplateTestingData: 'create-template-testing-data',
  createTemplateTestingTest: 'create-template-testing-test',

  createExternalAuthToken: 'create-external-auth-token',
};
